/* eslint-disable indent */
/* eslint-disable quotes */
/* eslint-disable no-unused-vars */
import React, { useState } from "react";
import Heading from "../../components/Heading";
import "./style.scss";
import DAList from "./DAList";
import { Tabs } from "antd";
import SyncedDA from "./SyncedDA";
import NotSyncedDA from "./NotSyncedDA";

const DAManagement = () => {
    const [activeKey, setActiveKey] = useState("1");

    const onChange = (key) => {
        setActiveKey(key);
    };
    return (
        <div className="p-1">
            <Heading title="DA Management" />
            <div className="da-management-container">
                <DAList />
            </div>
        </div>
    //     <div className="p-1">
    //     <Heading title="DA Management" />
    //     <div className="da-management-container">
    //         <Tabs
    //             defaultActiveKey="1"
    //             activeKey={activeKey}
    //             onChange={onChange}
    //             items={[
    //                 {
    //                     label: "Not Synced to Innofulfill",
    //                     key: "1",
    //                     children: <NotSyncedDA syncStatus={false} />
    //                 },
    //                 {
    //                     label: "Synced to Innofulfill",
    //                     key: "2",
    //                     children: <SyncedDA syncStatus={true} />
    //                 }
    //             ]}
    //         />
    //     </div>
    // </div>
    );
};

export default DAManagement; 
